module.exports = __webpack_public_path__ + "html/subscription-predict-price-container_cac2967847b1834ec43c5533b61a6bf7.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/settings/subscription/containers/subscription-predict-price-container.html
// module id = gGiH
// module chunks = 3 9 16